import { createSelector } from 'reselect';
import { getProps } from 'helpers';

import { itemsContainer } from '../base';

export const eventsSelector = createSelector(
  [itemsContainer],
  ({ events }) => ({ events }),
);

export const addOnEventsSelector = createSelector(
  [itemsContainer],
  ({ events }) => ({ addOnEvents: Object.values(events).filter((event) => event.isAddOn) }),
);

export const eventByIdSelector = createSelector(
  [itemsContainer, getProps],
  ({ events }, { id }) => ({ event: events[id] }),
);
